export default __webpack_public_path__ + "static/media/bth-day-balloons.8c72a5b4.png";